class Autocomplete {

	constructor() {
		this.init();
	}

	init() {
    ( function( $ ) {
			$('#search_form').on('submit', function(e){
				e.preventDefault();
      });

      $(document).on('keyup', function(e){
				e.preventDefault();

        if(e.keyCode === 27 && $('#site-navigation.search-open').length){
          $('#navgiation-search, #site-navigation, #content, #breadcrumbs').toggleClass('search-open');
        }
      });

      $('#search').autocomplete({
				autoSelectFirst: true,
      	serviceUrl: variables.ajax_url,
      	type: 'POST',
      	dataType: 'json',
      	paramName: 'term',
        noCache: true,
      	params: { action: function(){ return 'global_search'; } },
        showNoSuggestionNotice: true,
        noSuggestionNotice: '<div class="search-header-autocomplete-result no-icon">' + $('#search-no-results-text').text() + '</div>',
      	minChars: 1,
        triggerSelectOnValidInput: false,
				onSelect: function (suggestion) {
					window.location = suggestion.link;
      	},
      	formatResult: function (suggestion, currentValue) {
					if(suggestion.type == 'products'){
						let suggestionHtml = '';
						suggestionHtml += '<div class="search-header-autocomplete-result products">';
						suggestionHtml += '<div class="image"><img src="'+suggestion.image+'"></div>';
						suggestionHtml += '<div><label>'+suggestion.company+'</label><h4>'+suggestion.value+'</h4></div>';
						suggestionHtml += '</div>';

						return suggestionHtml;
					}else{
      			return '<div class="search-header-autocomplete-result">'+suggestion.value+'</div>';
					}
      	},
      });
    }( jQuery ) );
	}
}

export default Autocomplete;
